/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-generic-overlay',
    templateUrl: './generic-overlay.component.html',
    styleUrls: ['./generic-overlay.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
/**
 * This is a generic overlay component, to be used on cancel/delete scenarios actions
 */
export class GenericOverlayComponent {
    @Input() firstButtonTitle = 'Cancel';
    @Input() secondButtonTitle = 'Delete';
    @Input() firstButtonEnabled = true;
    @Input() secondButtonEnabled = true;
    @Input() isSpinner = false;
    @Output() firstButtonEvent = new EventEmitter<void>();
    @Output() secondButtonEvent = new EventEmitter<void>();

    constructor() {
    }

    clickFirstButton(): void {
        this.firstButtonEvent.emit();
    }

    clickSecondButton(): void {
        this.secondButtonEvent.emit();
    }
}
